import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { FlexRow } from 'components/Layouts';
import { COLORS } from 'constants/styles';
import Sidebar from './sidebar';

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
`;

const SuperAdmin = () => {
  return (
    <ContentContainer>
      <Sidebar />

      <FlexRow alignItems="center" overflowScroll fullHeight flexColumn padding="20px">
        <Outlet />
      </FlexRow>
    </ContentContainer>
  );
};

export default SuperAdmin;
